module.exports = __webpack_public_path__ + "img/battery_0disable.e3c8395f.png";